<template>
    <Modal>
        <template #title>System info</template>

        <p>
            Trim Designer was updated.
            <br>
            Please, <b>reload</b> the page!
        </p>

        <template #footer>
            <Button @click="closeModal">Reload</Button>
        </template>
    </Modal>
</template>

<script>
    import Modal from "../../components/Modal";
    import Button from "../../components/Button";

    export default {
        name: "ReloadPageModal",

        components: {
            Button,
            Modal,
        },

        methods: {
            closeModal() {
                this.$emit('closeModal');
            },

        },

    }
</script>

<style>

</style>